import { PlusOutlined, UploadOutlined, DeleteFilled } from "@ant-design/icons";
import {
  Button,
  Card as Card1,
  Checkbox,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Upload,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { createRef, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { Select as VendorSelect } from "react-select";
import VendorSelect from "./vendor.select";
import { toast } from "react-toastify";
import { Card, CardBody, Container } from "reactstrap";
import { Breadcrumbs, H5, H6 } from "../../../../AbstractElements";
import {
  GSTAPI,
  PoApi,
  PoWoApi,
  ProjectAddressApi,
  ProjectApi,
  ProjectFileApi,
  VendorApi,
} from "../../../../api";
import { fetchOrganisationDetails } from "../../../../api/organisation.api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import { poCreationAndEditGranted } from "../../../../utils/PermissionFunctions/userPermissions";
import AdditionalCharges from "./additionalCharges";
import { DocumentUpload } from "./document-upload";
import ItemTable from "./itemTable";
import PaymentTerms from "./paymentTerms";
import TaxAmount from "./taxAmount";
import TermsAndConditions from "./termsAndConditions";
import EditableTable from "./editableTable";
import { NewVendorForm } from "./new-vendor.form";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const poOptions = [
  {
    id: 1,
    label: "PO",
    value: "po",
  },
  {
    id: 2,
    label: "WO",
    value: "wo",
  },
  {
    id: 3,
    label: "Internal",
    value: "internal",
  },
  {
    id: 4,
    label: "Estimate",
    value: "estimate",
  },
];
const POForm = (props) => {
  const poFormRef = useRef();
  const logger = React.useContext(LoggerContext);
  const defaultTaxes = [
    {
      id: 1,
      label: "None",
      value: "none",
      tax_value: 0,
    },
    {
      id: 6,
      label: "5% CGST/SGST",
      value: "cgst_sgst",
      tax_value: 5,
    },
    {
      id: 7,
      label: "12% CGST/SGST",
      value: "cgst_sgst",
      tax_value: 12,
    },
    {
      id: 8,
      label: "18% CGST/SGST",
      value: "cgst_sgst",
      tax_value: 18,
    },
    {
      id: 9,
      label: "28% CGST/SGST",
      value: "cgst_sgst",
      tax_value: 28,
    },
    {
      id: 2,
      label: "5% IGST",
      value: "igst",
      tax_value: 5,
    },
    {
      id: 3,
      label: "12% IGST",
      value: "igst",
      tax_value: 12,
    },
    {
      id: 4,
      label: "18% IGST",
      value: "igst",
      tax_value: 18,
    },
    {
      id: 5,
      label: "28% IGST",
      value: "igst",
      tax_value: 28,
    },
  ];
  const attatchmentFormRef = useRef();
  const { Option } = Select;
  const history = useNavigate();
  const { poId } = useParams();
  const location = useLocation();
  const { user } = props.settings;
  console.log(location.state, "dgyuwg");
  const projectId = props.settings?.project?.id;
  // const { userDetails, setUserDetails } = useAPIUser();
  const [organisationDetails, setOrganisationDetails] = useState({});
  const [vendors, setVendors] = useState([]);
  const [fileInput, setFileInput] = useState(null);
  const [editId, setEditId] = useState(null);
  const [poDetails, setPoDetails] = useState(null);
  const [gst, setGst] = useState([]);
  const [projectAddress, setProjectAddress] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [items, setItems] = useState([]);
  const [defaultTax, setDefaultTax] = useState(null);
  const [additionalCharges, setAdditionalCharges] = useState([]);
  const [taxTypes, setTaxTypes] = useState([]);
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [projectDetails, setProjectDetails] = useState();
  const [defaultPaymentTerms, setDefaultPaymentTerms] = useState([]);
  const [defaultAdditionalCharges, setDefaultAdditionalCharges] = useState([]);
  const [leadId, setLeadId] = useState("");

  const [fileList, setFileList] = useState([]);
  const [fileUploading, setFileUploading] = useState(false);

  const [newVendorDrawer, setNewVendorDrawer] = useState(false);

  const [displayAddress, setDisplayAddress] = useState(null);

  const [visibleAddress, setVisibleAddress] = useState(false);
  const [loading, setLoading] = useState(false);
  const [documentModalVisible, setDocumentModalVisible] = useState(false);
  const formRefAddress = useRef();
  const showDrawerAddress = () => {
    setVisibleAddress(true);
  };

  const onNewVendor = () => {
    setNewVendorDrawer(true);
  };

  const onCloseAddress = () => {
    formRefAddress.current.resetFields();
    setVisibleAddress(false);
  };
  const [newAddress, setNewAddress] = useState({
    label: "",
    city: "",
    pincode: "",
    address: "",
  });
  // const [intraState, setIntraState] = useState(false);
  const [currentGst, setCurrentGst] = useState(null);
  const [totalRoundOff, setTotalRoundOff] = useState(false);
  const [finalValue, setFinalValue] = useState({
    type_of_order: "po",
    delivery_date: moment().format("YYYY-MM-DD"),
    organisation: user?.organisation?.organisation_id,
    project: props.settings?.project?.id,
    terms_and_condition: "",
    vendor: null,
    total_po_raised_amount: "",
    terms_and_conditions_description: "",
    gst: "",
    address: "",
    documents: [],
    lead_id: "",
  });
  useEffect(() => {
    getOrganisationDetails();
    fetchProjectDetails();
    fetchVendors({ branch: props.settings.branch?.id });
    fetchGst({ organisation: user?.organisation?.organisation_id });
    fetchAddress({ project: props.settings?.project?.id });
    if (location?.state?.editId) {
      setEditId(location?.state?.editId);
      fetchPoDetails(poId ?? location?.state?.editId);
    } else {
      setItemsFromRedux();
    }
  }, []);

  const setItemsFromRedux = () => {
    const leadIdFromRedux =
      props.settings?.selected_budget_items?.project_selected_items_lead_id;
    var arrayProjects =
      props.settings.selected_budget_items?.project_selected_items ?? [];

    if (leadIdFromRedux) {
      setLeadId(leadIdFromRedux);
    }

    const indexOfProject = arrayProjects.findIndex(
      (element) => element?.project_id == props.settings?.project?.id
    );
    console.log(
      "items",
      props.settings.selected_budget_items?.project_selected_items
    );
    if (indexOfProject > -1) {
      let itemsForProject = [...arrayProjects[indexOfProject]?.selected_items];
      itemsForProject = itemsForProject.map((item) => {
        return {
          key: item.id,
          ...item,
        };
      });
      setItems(itemsForProject);
      if (arrayProjects[indexOfProject]?.vendor_id) {
        const vendor = vendors?.find(
          (each) => each.id === arrayProjects[indexOfProject]?.vendor_id
        );
        setSelectedVendor({
          ...vendor,
          label: vendor?.name,
          value: vendor?.id,
        });
      }
    }
  };
  const setVendorFromRedux = () => {
    var arrayProjects =
      props.settings.selected_budget_items?.project_selected_items ?? [];

    const indexOfProject = arrayProjects.findIndex(
      (element) => element?.project_id == props.settings?.project?.id
    );
    if (indexOfProject > -1) {
      if (arrayProjects[indexOfProject]?.vendor_id) {
        if (vendors?.length > 0) {
          const finalVendor = vendors?.find(
            (each) => each.id === arrayProjects[indexOfProject]?.vendor_id
          );
          console.log(
            "finalVendor",
            arrayProjects,
            finalVendor,
            indexOfProject,
            arrayProjects[indexOfProject]?.vendor_id
          );
          setSelectedVendor({
            ...finalVendor,
            label: finalVendor?.name,
            value: finalVendor?.id,
          });
        }
      }
    } else {
      if (vendors?.length > 0) {
        setSelectedVendor({
          ...vendors[0],
          label: vendors[0]?.name,
          value: vendors[0]?.id,
        });
      }
    }
  };
  const fetchPoDetails = (id) => {
    axios.get(`${PoWoApi}${id}/`).then((res) => {
      setPoDetails(res.data);

      poFormRef?.current?.setFieldsValue({
        type_of_order: res.data.type_of_order,
        delivery_date: moment(res.data.delivery_date),
        vendor: res.data.vendor.id,
        gst: res.data.gst?.id,
        address: res.data.address?.id,
      });
      setDisplayAddress(res.data.address);
      setFinalValue({
        type_of_order: res.data.type_of_order,
        delivery_date: res.data.delivery_date,
        organisation: res.data.organisation,
        project: res.data.project.id,
        vendor: res.data.vendor.id,
        terms_and_condition: res.data?.terms_and_condition?.id,
        total_po_raised_amount: res.data.total_po_raised_amount,
        terms_and_conditions_description:
          res.data.terms_and_conditions_description,
        gst: res.data.gst?.id,
        address: res.data.address?.id,
        documents: res?.data?.documents,
        lead_id: res?.data?.lead_id,
      });
      setLeadId(res?.data?.lead_id);
      setFileList(res?.data?.documents);
      setSelectedVendor({
        ...res.data.vendor,
        label: res.data?.vendor?.name,
        value: res.data?.vendor?.id,
      });

      setDefaultPaymentTerms(res.data.po_payment_terms);
      setPaymentTerms(res?.data?.po_payment_terms);
      var addArr = res?.data?.po_additional_charges ?? [];
      if (addArr?.length === 0) {
        setDefaultAdditionalCharges([]);
      } else {
        for (var i = 0; i < addArr?.length; i++) {
          addArr[i].total =
            addArr[i].amount + addArr[i].amount * addArr[i].tax_value * 0.01;
        }
        console.log(addArr[i], "addArr");
        setDefaultAdditionalCharges(addArr);
      }
      var selectedArr = [];
      var items = res.data?.po_items;
      for (var i = 0; i < items?.length; i++) {
        if (items[i].sub_item) {
          var subItem = items[i].sub_item;
          var selectedObj = {
            boq_sub_item: subItem?.boq_sub_item,
            brand: subItem?.brand,
            budget_price: subItem?.budget_price,
            unit_po_price: items[i]?.unit_po_price,
            category_name: subItem?.category_name,
            discount: items[i]?.discount ?? 0,
            item: items[i]?.item?.id,
            sub_item: subItem?.id,
            id: subItem?.id,
            item_description: subItem?.item_description,
            quantity: items[i]?.quantity,
            tax_value: items[i]?.tax_value,
            tax_type: items[i]?.tax_type,
            unit: subItem?.unit,
            total: items[i]?.total_price,
          };
          selectedArr.push(selectedObj);
        } else {
          var item = items[i].item;
          var selectedObj = {
            boq_item: item?.boq_item,
            brand: item?.brand,
            budget_price: item?.budget_price,
            unit_po_price: items[i]?.unit_po_price,
            category_name: item?.category_name,
            discount: items[i]?.discount ?? 0,
            item: item?.id,
            id: item?.id,
            item_description: item?.item_description,
            quantity: items[i]?.quantity,
            tax_value: items[i]?.tax_value,
            tax_type: items[i]?.tax_type,
            unit: item?.unit,
            sub_items: [],
            remark: item?.remark,
            project: item?.project,
            total: items[i]?.total_price,
          };
          selectedArr.push(selectedObj);
        }
      }
      console.log("selectedArr", selectedArr);
      setItems([...selectedArr]);
    });
  };
  useEffect(() => {
    console.log(selectedVendor, "selectedVendor");
    let fieldsValue = poFormRef.current.getFieldsValue();
    fieldsValue.vendor = selectedVendor?.id;
    poFormRef.current.setFieldsValue(fieldsValue);
    setFinalValue({ ...finalValue, vendor: selectedVendor?.id });
  }, [additionalCharges, items, selectedVendor]);

  useEffect(() => {
    if (location.pathname.includes("edit")) {
      // const vendor = vendors?.filter((each) => each.id === finalValue.vendor);
      // setSelectedVendor({
      //   ...vendor,
      //   label: vendor?.name,
      //   value: vendor?.id,
      // });
    } else {
      setVendorFromRedux();
    }
  }, [vendors]);

  const getOrganisationDetails = () => {
    fetchOrganisationDetails().then((res) => {
      setOrganisationDetails(res);
    });
  };

  const fetchProjectDetails = () => {
    axios.get(`${ProjectApi}${props.settings?.project?.id}/`).then((res) => {
      setProjectDetails(res.data);
    });
  };

  const fetchVendors = (params = {}) => {
    axios
      .get(`${VendorApi}`, {
        params: { ...params, branch: props?.settings?.branch?.id },
      })
      .then((res) => {
        setVendors(res.data);
      });
  };

  const fetchGst = (params = {}) => {
    axios.get(`${GSTAPI}`, { params: { ...params } }).then((res) => {
      setGst(res.data);
    });
  };

  // useEffect(() => {
  //   // setGstInFinalValue();
  // }, [gst]);

  // useEffect(() => {
  //   // setGstInFinalValue();
  // }, [poDetails]);

  useEffect(() => {
    const current = gst?.find((item) => item?.id == poDetails?.gst?.id);
    console.log("current", current, poDetails?.gst?.id, gst);
    setCurrentGst({ ...current });
  }, [gst, poDetails]);

  const setGstInFinalValue = () => {
    console.log("setGstInFinalValue");
    setTimeout(() => {
      if (gst?.length > 0 && !location.pathname.includes("edit")) {
        let values = poFormRef.current.getFieldsValue();
        values = {
          ...values,
          gst: gst[0].id,
        };
        poFormRef.current.setFieldsValue(values);
        setFinalValue({
          ...finalValue,
          gst: gst[0].id,
        });
        setCurrentGst({ ...gst[0] });
      } else if (gst?.length > 0 && poDetails?.gst?.id) {
        let values = poFormRef.current.getFieldsValue();
        const current = gst?.find((item) => item?.id == poDetails?.gst?.id);
        console.log("current", current, poDetails?.gst?.id, gst);
        setCurrentGst({ ...current });
        values = {
          ...values,
          gst: current.id,
        };
        poFormRef.current.setFieldsValue(values);
      }
    }, 500);
  };

  const fetchAddress = (params = {}) => {
    axios.get(`${ProjectAddressApi}`, { params: { ...params } }).then((res) => {
      setProjectAddress(res.data);

      if (!location?.state?.editId) {
        setFinalValue({ ...finalValue, address: res.data[0]?.id });
      }
      // setGstInFinalValue();
      // setDisplayAddress(res.data[0]);
    });
  };

  const sendPo = () => {
    const newValue = finalValue;
    if (props.settings?.organisation?.lead_field) {
      if (leadId.trim() === "") {
        toast.error("Please enter lead ID");
        return;
      }
    }
    logger.log(LogEvents.sendPO, {});
    setLoading(true);
    console.log(newValue);
    if (displayAddress?.address == "") {
      toast.error("Please select address");
      setLoading(false);

      return;
    }
    if (
      newValue.type_of_order &&
      newValue.delivery_date &&
      newValue.project &&
      newValue.vendor
    ) {
      if (items.length < 1) {
        toast.error("Choose at least one item!");
        setLoading(false);

        return;
      }
      const full_percentage = paymentTerms?.reduce((acc, obj) => {
        return acc + obj.percentage;
      }, 0);
      if (full_percentage !== 100) {
        toast.error("Total Percentage for terms should be 100!");
        setLoading(false);
        return;
      }

      var totalAdditonalCharges = additionalCharges?.reduce((acc, obj) => {
        return acc + obj.total;
      }, 0);
      newValue.total_po_raised_amount = totalRoundOff
        ? Math.ceil(getTotalAmount())
        : getTotalAmount();
      var arr = items;
      var newArr = [];
      for (var i = 0; i < arr?.length; i++) {
        var data = arr[i];
        console.log(arr[i], "arr[i]");
        var total = Number(data?.quantity) * Number(data?.unit_po_price);
        var discount = data?.discount ?? 0;
        var price = total - total * (discount ?? 0) * 0.01;
        var tax = data?.tax_value;
        price += price * 0.01 * tax;

        const formData = {
          item: data.id,
          quantity: data.quantity,
          discount: data.discount ?? 0,
          tax_value: data.tax_value,
          tax_type: data.tax_type,
          total_price: price, // Fix
          unit_po_price: data.unit_po_price,
        };
        if (data.boq_sub_item) {
          formData.item = data.item_id ?? data?.item;
          formData.sub_item = data.id ?? data.sub_item;
        } else {
          formData.item = data.id;
        }

        if (location.pathname.includes("edit")) {
          if (data.sub_item || data.boq_sub_item) {
            formData.item = data.item_id ?? data?.item;
            formData.sub_item = data.id;
          } else {
            formData.item = data.id;
          }
        }
        newArr.push(formData);
        console.log("formData", formData);
      }
      newValue.po_items = newArr;
      newValue.gst = currentGst?.id;
      newValue.po_additionals = additionalCharges;
      newValue.documents = newValue.documents?.map((doc) => doc.id);
      if (location.pathname.includes("edit")) {
        newValue.po_id = poId ?? location.state.editId;
        newValue.po_number = poDetails?.po_number;
      }
      var arr1 = [];
      for (var i = 0; i < paymentTerms.length; i++) {
        let paymentTermTemp = paymentTerms[i];
        console.log("PO payment 1", paymentTermTemp);
        if (paymentTermTemp?.deadline) {
          console.log("PO payment 2", paymentTermTemp);
          paymentTermTemp.deadline = moment(paymentTerms[i]?.deadline).format(
            "YYYY-MM-DD"
          );
        } else {
          delete paymentTermTemp.deadline;
        }
        if (paymentTermTemp?.percentage > 0) arr1.push(paymentTermTemp);
      }
      newValue.po_payment_terms = arr1;
      const selectedAddress = projectAddress?.find(
        (address) => address?.id == displayAddress?.id
      );
      newValue.address = selectedAddress?.id;
      newValue.address_description =
        selectedAddress?.address +
        ", " +
        selectedAddress?.city +
        ", " +
        selectedAddress?.pincode;
      newValue.lead_id = leadId;
      console.log("PO payment final 3", arr1, newValue, currentGst);

      axios
        .post(`${PoApi}`, newValue)
        .then((res) => {
          var po = res.data.id;

          //Send Items
          // var arr1 = paymentTerms;
          // for (var i = 0; i < arr1.length; i++) {
          //   const formData = new FormData();
          //   formData.append("term", arr1[i].term);
          //   formData.append("percentage", arr1[i].percentage);
          //   formData.append(
          //     "deadline",
          //     moment(arr1[i].deadline).format("YYYY-MM-DD")
          //   );
          //   formData.append("po", po);
          //   axios.post(`${PoTermsApi}`, formData);
          // }

          // //Send Additional Charges
          // var arr2 = additionalCharges;
          // for (var i = 0; i < arr2.length; i++) {
          //   const formData = new FormData();
          //   formData.append("charge_type", arr2[i].charge_type);
          //   formData.append("amount", arr2[i].amount);
          //   formData.append("tax", arr2[i].tax);
          //   formData.append("po", po);
          //   axios.post(`${PoAdditionalChargesApi}`, formData);
          // }

          // //Send Documents
          // var arr3 = fileList;
          // for (var i = 0; i < arr3.length; i++) {
          //   var formData = new FormData();
          //   formData.append("document", arr3[i], arr3[i].name);
          //   formData.append("po", po);
          //   axios.post(`${PoDocumentsApi}`, formData).then(() => {
          //     toast.success("Document Uploaded!");
          //   });
          // }
        })
        .then(() => {
          history(`/app/project/powo/`, {
            state: { id: props.settings?.project?.id },
          });
          toast.success("PO sent successfully!");
          setLoading(false);
        })
        .catch(() => {
          toast.error("Something went wrong!");
          setLoading(false);
        });
    } else {
      toast.error("Enter all fields!");
      setLoading(false);
    }
  };

  const getFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["B", "KB", "MB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(parseFloat(bytes / Math.pow(k, i))) + " " + sizes[i];
  };

  const onDocumentAdd = async (file) => {
    try {
      setFileUploading(true);
      const result = await Promise.all(
        Object.keys(file).map((key) => {
          console.log("KK", key, file[key]);
          const formData = new FormData();
          formData.append("file", file[key], file[key].name);
          formData.append("file_name", file[key].name);
          formData.append("project", props.settings?.project?.id);
          formData.append("file_size", getFileSize(file[key]?.size));
          return axios
            .post(ProjectFileApi, formData)
            .then((res) => {
              let finalValueTemp = { ...finalValue };
              finalValueTemp.documents?.push({
                document: res?.data?.file,
                id: res?.data?.id,
                file_name: res?.data?.file_name,
              });
              setFileList([...finalValueTemp.documents]);
              setFinalValue({ ...finalValueTemp });
            })
            .catch((e) => {
              console.log("e", { e });
              toast.error("Something went wrong!");
            });
        })
      );

      toast.success("Files Upload Successfully !");
      // if (Array.isArray(file)) {
      //   const result = await Promise.all(
      //     file.map(async (file) => uploadDocument(file))
      //   );
      //   setFileList([...fileList, ...result]);
      //   setFinalValue({
      //     ...finalValue,
      //     documents: [...finalValue.documents, ...result],
      //   })
      // } else {
      //   const result = await uploadDocument(file);
      //   setFileList([...fileList, result]);
      //   setFinalValue({
      //     ...finalValue,
      //     documents: [...finalValue.documents, result],
      //   });
      // }
    } catch (e) {
      console.log("i-log> ", e);
    } finally {
      setFileUploading(false);
    }
  };

  const onDocumentRemove = (file) => {
    const id = file.id;
    console.log(
      "i-log> files",
      fileList,
      fileList.filter((file) => file.id !== id)
    );
    setFileList(fileList.filter((file) => file.id !== id));
    setFinalValue({
      ...finalValue,
      documents: finalValue.documents.filter((file) => file.id !== id),
    });
  };

  const handleTermsandConditions = ({
    id,
    terms_and_conditions_description,
  }) => {
    console.log("handleTermsandContions", id);
    setFinalValue({
      ...finalValue,
      terms_and_condition: id,
      terms_and_conditions_description: terms_and_conditions_description,
    });
  };
  const handleTermsandConditionsDesc = (value) => {
    console.log("handleTermsandContions", value);
    setFinalValue({
      ...finalValue,
      terms_and_conditions_description: value,
    });
  };
  const addNewAddress = () => {
    const updatedValues = formRefAddress.current.getFieldsValue();
    const values = new FormData();
    values.append("label", updatedValues.label);
    values.append("city", updatedValues.city);
    values.append("pincode", updatedValues.pincode);
    values.append("address", updatedValues.address);
    values.append("project", props.settings?.project?.id);
    values.append("contact_person", updatedValues.contact_person);
    values.append("contact_phone", updatedValues.contact_phone);
    values.append("contact_email", updatedValues.contact_email);
    values.append("google_map_address", updatedValues.google_map_address);

    axios
      .post(`${ProjectAddressApi}`, values)
      .then((res) => {
        toast.success("Successfully added address!");
        fetchAddress({ project: props.settings?.project?.id });
        onCloseAddress();
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };

  const getTotalTaxableAmount = () => {
    let amount = 0;
    items?.map((item) => {
      amount +=
        item.quantity * item.unit_po_price -
        item.quantity * item.unit_po_price * 0.01 * item.discount;
      console.log("amount taxable", item, amount);
    });
    return amount;
  };

  const setTaxForAllItems = (tax_id) => {
    const tax_selected = defaultTaxes.find((tax) => tax.id == tax_id);
    const allItems = [...items];
    allItems?.map((item) => {
      item.tax_type = tax_selected?.value;
      item.tax_value = tax_selected?.tax_value;
    });
    console.log("allItems", allItems);
    setItems(allItems);
  };

  const getTotalAmount = () => {
    let amount = 0;
    items?.map((item) => {
      var quantity = Number(item.quantity) ?? 0;
      var unit_po_price = Number(item.unit_po_price) ?? 0;
      var discount = Number(item.discount) ?? 0;
      var tax_value = Number(item.tax_value) ?? 0;

      amount +=
        (quantity ?? 0) * (unit_po_price ?? 0) -
        (quantity ?? 0) * (unit_po_price ?? 0) * 0.01 * (discount ?? 0) +
        ((quantity ?? 0) * (unit_po_price ?? 0) -
          (quantity ?? 0) * (unit_po_price ?? 0) * 0.01 * (discount ?? 0)) *
          (tax_value ?? 0) *
          0.01;
      console.log("amount", item, amount);
    });
    amount +=
      additionalCharges?.reduce((acc, obj) => {
        return (Number(acc) ?? 0) + (Number(obj.total) ?? 0);
      }, 0) ?? 0;
    return amount;
  };

  const ref = createRef();
  const formRef = createRef();

  const addVendor = () => {
    logger.log(LogEvents.vendorSubmit, {});
    const updatedValues = formRef.current.getFieldsValue();
    console.log("updatedValues", updatedValues);
    if (
      updatedValues?.name &&
      updatedValues?.contact?.toString()?.match(/^\d{10}$/) &&
      updatedValues?.email?.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      ) &&
      updatedValues?.pincode?.match(/^\d{6}$/)
    ) {
      const values = new FormData();
      // if (tags.length > 0) {
      //   values.append("vendor_type", JSON.stringify(tags));
      // } else {
      //   values.append("vendor_type", JSON.stringify([]));
      // }
      values.append("name", updatedValues.name);
      values.append(
        "vendor_code",
        updatedValues.vendor_code ? updatedValues.vendor_code : ""
      );
      values.append(
        "contact",
        updatedValues.contact ? updatedValues.contact : ""
      );
      values.append(
        "billing_address",
        updatedValues.billing_address ? updatedValues.billing_address : ""
      );
      values.append(
        "pincode",
        updatedValues.pincode ? updatedValues.pincode : ""
      );
      // values.append(
      //   "vendor_type",
      //   updatedValues.vendor_type ? updatedValues.vendor_type : ""
      // );

      values.append(
        "category",
        updatedValues.category ? updatedValues.category : ""
      );
      // updatedValues?.category?.map((b) => {
      //   values.append("category", b);
      // });
      values.append(
        "pan_number",
        updatedValues.pan_number ? updatedValues.pan_number : ""
      );
      values.append(
        "organisation",
        props.settings?.user?.organisation?.organisation_id
      );
      values.append("branch", props?.settings?.branch?.id);
      values.append("gst", updatedValues.gst ? updatedValues.gst : "");
      values.append("email", updatedValues.email ? updatedValues.email : "");
      values.append(
        "contact_person",
        updatedValues.contact_person ? updatedValues.contact_person : ""
      );
      values.append(
        "billing_address",
        updatedValues.billing_address ? updatedValues.billing_address : ""
      );
      values.append(
        "bank_ifsc",
        updatedValues.bank_ifsc ? updatedValues.bank_ifsc : ""
      );
      values.append(
        "bank_account_number",
        updatedValues.bank_account_number
          ? updatedValues.bank_account_number
          : ""
      );
      values.append(
        "bank_account_holder",
        updatedValues.bank_account_holder
          ? updatedValues.bank_account_holder
          : ""
      );
      axios
        .post(`${VendorApi}`, values)
        .then((res) => {
          toast.success("Vendor Added Successfully!");
          fetchVendors();
          setNewVendorDrawer(false);
        })
        .catch((e) => {
          console.log("i-log> vendor add error", e);
          toast.error("Something went wrong!");
        });
    } else {
      toast.error("Enter Required Fields");
    }
  };

  const roundOffTotalAmount = (e) => {
    setTotalRoundOff(e.target.checked);
  };

  // React.useEffect(() => {
  //   if (currentGst?.gst_no && selectedVendor?.gst) {
  //     const gst = currentGst?.gst_no;
  //     const vendorGst = selectedVendor?.gst;
  //     if (gst?.length > 0 && vendorGst?.length > 0) {
  //       if (gst?.substring(0, 2) === vendorGst?.substring(0, 2)) {
  //         setIntraState(true);
  //       } else {
  //         setIntraState(false);
  //       }
  //     }
  //   }
  // }, [currentGst?.gst_no, selectedVendor?.gst]);

  // React.useEffect(() => {
  //   console.log("intraState", intraState, items);
  //   if (intraState) {
  //     setItems(items.map((item) => ({ ...item, tax_type: "igst" })));
  //   }
  // }, [intraState, items.length]);

  return (
    <React.Fragment>
      <Breadcrumbs parent="Project" title="PO/WO Form" mainTitle="PO/WO Form" />
      <Container fluid={true}>
        <Spin
          spinning={loading}
          size="large"
          style={{ position: "fixed", marginTop: "30vh" }}
        >
          <Card ref={ref}>
            <CardBody>
              <Form ref={poFormRef} id="poForm">
                {/* Main Details */}
                <Row gutter={24}>
                  <Col sm={12}>
                    <img
                      src="https://mysite-user-images.s3.ap-south-1.amazonaws.com/1659693186644-MD-for-procurement.svg"
                      height={80}
                    />
                  </Col>
                  <Col sm={12}>
                    <Row gutter={16} className="mt-3">
                      <Col sm={5} md={5}>
                        Created By
                      </Col>
                      <Col sm={19} md={19}>
                        <Row>
                          <Col sm={1}>:</Col>
                          <Col sm={22}>
                            {" " +
                              user?.name +
                              " (" +
                              user?.contact +
                              ", " +
                              user?.email +
                              ")"}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row gutter={16} className="mt-3">
                      <Col sm={5} md={5}>
                        Type of Order
                      </Col>
                      <Col sm={19} md={19}>
                        <Row>
                          <Col sm={1}>:</Col>
                          <Col sm={11}>
                            <Form.Item
                              name="type_of_order"
                              rules={[
                                {
                                  required: true,
                                  message: "Order Type is required",
                                },
                              ]}
                            >
                              <Select
                                className="w-100"
                                key={"type_of_order"}
                                defaultValue={finalValue?.type_of_order ?? "PO"}
                                value={finalValue?.type_of_order}
                                onChange={(e) => {
                                  setFinalValue({
                                    ...finalValue,
                                    type_of_order: e,
                                  });
                                }}
                              >
                                {poOptions?.map((each) => (
                                  <Option value={each?.value} key={each?.id}>
                                    {each?.label}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row gutter={16} className="mt-3">
                      <Col sm={5} md={5}>
                        Delivery Date
                      </Col>
                      <Col sm={19} md={19}>
                        <Row>
                          <Col sm={1}>:</Col>
                          <Col sm={11}>
                            <Form.Item
                              name="delivery_date"
                              rules={[
                                {
                                  required: true,
                                  message: "Delivery Date is required",
                                },
                              ]}
                            >
                              <DatePicker
                                value={moment(finalValue.delivery_date)}
                                allowClear={false}
                                defaultValue={moment(finalValue?.delivery_date)}
                                onChange={(e) => {
                                  setFinalValue({
                                    ...finalValue,
                                    delivery_date:
                                      moment(e).format("YYYY-MM-DD"),
                                  });
                                }}
                                className="w-100"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/* Bill To */}
                <Row gutter={24} className="mt-3">
                  <Col sm={12}>
                    <Card1>
                      <div className="">
                        <H6>Bill To</H6>
                      </div>
                      <Row gutter={16} className="mt-3">
                        <Col sm={5} md={5}>
                          Name
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={11}>
                              {props.settings.branch?.branch_name}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={16} className="mt-3">
                        <Col sm={5} md={5}>
                          Address
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={11}>{currentGst?.address}</Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={16} className="mt-3">
                        <Col sm={5} md={5}>
                          PIN Code
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={11}>{currentGst?.pincode}</Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={16} className="mt-3">
                        <Col sm={5} md={5}>
                          GST Number
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={11}>{currentGst?.gst_no}</Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={16} className="my-3">
                        <Col sm={5} md={5}>
                          GST
                        </Col>
                        <Col sm={19} md={19}>
                          <Row>
                            <Col sm={1}>:{}</Col>
                            <Col sm={11}>
                              <Form.Item
                                name="gst"
                                // rules={[
                                //   {
                                //     required: true,
                                //     message: "GST is required",
                                //   },
                                // ]}
                              >
                                <Select
                                  value={finalValue?.gst}
                                  onChange={(e) => {
                                    setFinalValue({
                                      ...finalValue,
                                      gst: e,
                                    });
                                    console.log(
                                      gst.find((item) => item.id === e)
                                    );
                                    setCurrentGst(
                                      gst.find((item) => item.id == e)
                                    );
                                  }}
                                  key={"select_gst"}
                                  placeholder="GST"
                                  className="w-100"
                                >
                                  {gst?.map((each) => (
                                    <Option key={each.id} value={each.id}>
                                      {each?.label}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card1>
                  </Col>
                  {/* Vendor Details */}
                  <Col sm={12}>
                    <Card1 style={{ padding: "0px" }}>
                      <div className="">
                        <H6>Vendor Details</H6>
                      </div>
                      <Row gutter={16} className="mt-3">
                        <Col sm={6} md={6}>
                          Vendor Name
                        </Col>
                        <Col sm={18} md={18}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={22}>
                              <Form.Item
                                key={"select_vendor_form"}
                                name="vendor"
                                rules={[
                                  {
                                    required: true,
                                    message: "Vendor is required",
                                  },
                                ]}
                              >
                                <Space>
                                  <VendorSelect
                                    vendors={vendors}
                                    selectedVendor={selectedVendor}
                                    setSelectedVendor={setSelectedVendor}
                                    onNewVendor={onNewVendor}
                                    // options={vendors?.map((vendor) => ({
                                    //   value: vendor.id,
                                    //   label: vendor.name,
                                    // }))}
                                    // onChange={(selected) => {
                                    //   const selectedVendor = vendors.find(
                                    //     (vendor) => vendor.id == selected?.value
                                    //   );
                                    //   console.log(selectedVendor);
                                    //   setSelectedVendor(selectedVendor);
                                    // }}
                                  />
                                  <Button onClick={onNewVendor}>
                                    <PlusOutlined />
                                    Add vendor
                                  </Button>
                                </Space>
                                {/* <Select
                                  showSearch
                                  value={selectedVendor?.id}
                                  key={"select_vendor"}
                                  onChange={(e) => handleSelectVendor(e)}
                                  placeholder={"Select Vendor"}
                                  className="w-100"
                                >
                                  {vendorOptions}
                                </Select> */}
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={16} className="mt-3">
                        <Col sm={6} md={6}>
                          Address
                        </Col>
                        <Col sm={18} md={18}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={15}>{selectedVendor?.billing_address}</Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={16} className="mt-3">
                        <Col sm={6} md={6}>
                          Contact Details
                        </Col>
                        <Col sm={18} md={18}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={15}>
                              {selectedVendor?.contact}, {selectedVendor?.email}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={16} className="mt-3">
                        <Col sm={6} md={6}>
                          GST
                        </Col>
                        <Col sm={18} md={18}>
                          <Row>
                            <Col sm={1}>:</Col>
                            <Col sm={15}>{selectedVendor?.gst}</Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card1>
                  </Col>
                </Row>
                {/* SHIP */}
                <div className="mt-3">
                  <Card1>
                    <H6>Ship To</H6>
                    <Row gutter={24} className="mt-3">
                      <Col sm={12}>
                        <Row gutter={16}>
                          <Col sm={4} md={4}>
                            Name
                          </Col>
                          <Col sm={20} md={20}>
                            <Row>
                              <Col sm={1}>:</Col>
                              <Col sm={11}>{projectDetails?.project_name}</Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row gutter={24} className="mt-3">
                      <Col sm={12}>
                        <Row gutter={16}>
                          <Col sm={4} md={4}>
                            Address
                          </Col>
                          <Col sm={20} md={20}>
                            <Row>
                              <Col sm={1}>:</Col>
                              <Col sm={11}>
                                <Form.Item name="address">
                                  {JSON.stringify(projectDetails?.address)}
                                  <Select
                                    className="w-100"
                                    key={"select_address"}
                                    value={displayAddress?.id}
                                    optionFilterProp="children"
                                    placeholder={"Address"}
                                    onChange={(e) => {
                                      setFinalValue({
                                        ...finalValue,
                                        address: e,
                                      });
                                      setDisplayAddress(
                                        projectAddress.find(
                                          (addr) => addr.id === e
                                        )
                                      );
                                    }}
                                  >
                                    {projectAddress?.map((each) => {
                                      return (
                                        <Option key={each.id} value={each.id}>
                                          {each?.label}
                                        </Option>
                                      );
                                    })}
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col>
                                <Button
                                  style={{ marginLeft: "10px" }}
                                  icon={<PlusOutlined />}
                                  onClick={() => {
                                    showDrawerAddress();
                                  }}
                                >
                                  Add New Address
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {displayAddress && (
                      <Row gutter={24} className="mt-1">
                        <Col sm={12}>
                          Selected address: {displayAddress?.address},{" "}
                          {displayAddress?.city} {displayAddress?.pincode}
                          <Row>
                            {displayAddress?.contact_person && (
                              <Col sm={12}>
                                Contact Person: {displayAddress?.contact_person}
                              </Col>
                            )}
                            {displayAddress?.contact_phone && (
                              <Col sm={12}>
                                Contact Phone: {displayAddress?.contact_phone}
                              </Col>
                            )}
                            {displayAddress?.contact_email && (
                              <Col sm={12}>
                                Contact Email: {displayAddress?.contact_email}
                              </Col>
                            )}
                            {displayAddress?.google_map_address &&
                              displayAddress?.google_map_address !==
                                "undefined" && (
                                <Col sm={12}>
                                  Google Map Address:{" "}
                                  {displayAddress?.google_map_address}
                                </Col>
                              )}
                          </Row>
                        </Col>
                      </Row>
                    )}
                  </Card1>
                </div>
                <Col
                  style={{
                    display: "flex",
                    justifyContent: props.settings?.organisation?.lead_field
                      ? "space-between"
                      : "end",
                  }}
                  className="mt-3"
                >
                  {props.settings?.organisation?.lead_field && (
                    <div style={{ width: 300 }}>
                      <div style={{ textAlign: "left" }}>Lead ID</div>
                      <Input
                        value={leadId}
                        placeholder="Lead ID"
                        onChange={(e) => {
                          setLeadId(e.target.value);
                        }}
                      />
                    </div>
                  )}

                  <div style={{ width: 300 }}>
                    <div style={{ textAlign: "right" }}>
                      Set default tax for all items
                    </div>
                    <Select
                      size="medium"
                      style={{ textAlign: "right", width: "100%" }}
                      onChange={(value) => setTaxForAllItems(value)}
                    >
                      {defaultTaxes.map((tax) => (
                        <Select.Option
                          value={tax.id}
                          style={{ textAlign: "right" }}
                          key={tax.id}
                        >
                          {tax.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </Col>
                <div className="mt-3">
                  {/* {true && (
                    <Card1>
                      <EditableTable
                        projectId={props.settings?.project?.id}
                        editId={editId}
                        selectedRowKeys={items.map((item) => item.id)}
                        taxTypes={taxTypes}
                        setDefaultTax={setDefaultTax}
                        defaultSelectedItems={items}
                        setItems={setItems}
                      />
                    </Card1>
                  )} */}
                  <Card1>
                    <ItemTable
                      projectId={props.settings?.project?.id}
                      editId={editId}
                      selectedRowKeys={items.map((item) => item.id)}
                      taxTypes={taxTypes}
                      setDefaultTax={setDefaultTax}
                      defaultSelectedItems={items}
                      setItems={setItems}
                    />
                  </Card1>
                </div>
                <Row gutter={24} className="mt-3">
                  <Col sm={12}>
                    <Card1>
                      <PaymentTerms
                        setPaymentTerms={setPaymentTerms}
                        defaultPaymentTerms={defaultPaymentTerms}
                      />
                      <TermsAndConditions
                        handleTermsandConditionsDesc={
                          handleTermsandConditionsDesc
                        }
                        handleTermsandConditions={handleTermsandConditions}
                        defaultTC={finalValue?.terms_and_condition}
                        defaultTCDesc={
                          finalValue?.terms_and_conditions_description
                        }
                      />
                      <div className="">
                        <div>
                          <span
                            style={{ fontSize: "18px", fontWeight: "bolder" }}
                          >
                            Documents
                          </span>{" "}
                          {"(Total files size should be less than 25MB)"}
                        </div>
                        <div className="py-2">
                          <DocumentUpload
                            onDocumentAdd={onDocumentAdd}
                            onDocumentRemove={onDocumentRemove}
                            documents={fileList}
                            loading={fileUploading}
                          />
                        </div>
                      </div>
                    </Card1>
                  </Col>
                  <Col sm={12}>
                    <Card1>
                      <div className="d-flex justify-content-between">
                        <div className="">Taxable Amount</div>
                        <div className="">
                          ₹ {Number(getTotalTaxableAmount()).toFixed(2)}
                        </div>
                      </div>

                      <TaxAmount items={items} />
                      <AdditionalCharges
                        taxTypes={taxTypes}
                        setAdditionalCharges={setAdditionalCharges}
                        defaultAdditionalCharges={defaultAdditionalCharges}
                      />
                      <div className="my-2">
                        <hr />
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <H5>Total Amount</H5>
                        <div>
                          <H5>
                            ₹{" "}
                            {totalRoundOff
                              ? Math.ceil(Number(getTotalAmount())).toFixed(2)
                              : Number(getTotalAmount()).toFixed(2)}{" "}
                            {totalRoundOff &&
                              "(+ " +
                                (
                                  Math.ceil(Number(getTotalAmount())) -
                                  Number(getTotalAmount())
                                ).toFixed(2) +
                                ")"}
                          </H5>
                          <Checkbox
                            checked={totalRoundOff}
                            onChange={roundOffTotalAmount}
                          >
                            Round Off
                          </Checkbox>
                        </div>
                      </div>
                    </Card1>
                  </Col>
                </Row>
                {poCreationAndEditGranted(props.settings?.user) && (
                  <div className="d-flex justify-content-end">
                    {location.pathname.includes("edit") ? (
                      <Button
                        className="btn btn-primary text-white"
                        size="large"
                        form="poForm"
                        onClick={() => sendPo()}
                        htmlType="submit"
                      >
                        Save Changes
                      </Button>
                    ) : (
                      <Button
                        className="btn btn-primary text-white"
                        size="large"
                        form="poForm"
                        onClick={() => sendPo()}
                        htmlType="submit"
                      >
                        Send PO
                      </Button>
                    )}
                  </div>
                )}
              </Form>
            </CardBody>
          </Card>
        </Spin>
      </Container>
      <Drawer
        title={"Add Address"}
        width={500}
        onClose={() => {
          onCloseAddress();
        }}
        visible={visibleAddress}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              onClick={() => {
                onCloseAddress();
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              form="addressForm"
              type="primary"
              htmlType="submit"
              onClick={addNewAddress}
            >
              Submit
            </Button>
          </div>
        }
      >
        <Form layout="vertical" id="addressForm" ref={formRefAddress}>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"label"}
                label="Label"
                rules={[
                  {
                    required: true,
                    message: "Label is required",
                  },
                ]}
              >
                <Input placeholder="e.g. Bangalore Address" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"address"}
                label="Address"
                rules={[
                  {
                    required: true,
                    message: "Address is required",
                  },
                ]}
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 3,
                    maxRows: 20,
                  }}
                  placeholder="e.g. Bangalore Address"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"city"}
                label="City"
                rules={[
                  {
                    required: true,
                    message: "City is required",
                  },
                ]}
              >
                <Input placeholder="City" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"pincode"}
                label="Pincode"
                rules={[
                  {
                    required: true,
                    message: "Pincode is required",
                  },
                ]}
              >
                <Input
                  showCount
                  maxLength={6}
                  minLength={6}
                  placeholder="Pincode"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name="contact_person"
                label="Contact Person"
                rules={[
                  {
                    required: true,
                    message: "Contact Person is required",
                  },
                ]}
              >
                <Input placeholder="Contact Person" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"contact_phone"}
                label="Contact Phone"
                rules={[
                  {
                    required: true,
                    message: "Contact Phone is required",
                  },
                ]}
              >
                <Input placeholder="Contact Phone" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"contact_email"}
                label="Contact Email"
                rules={[
                  {
                    required: true,
                    message: "Contact Email is required",
                  },
                ]}
              >
                <Input placeholder="Contact Email" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name="google_map_address"
                label="Google Map Address"
                rules={[
                  {
                    required: true,
                    message: "Google Map Address is required",
                  },
                  {
                    type: "url",
                    message: "Please enter a valid URL",
                  },
                ]}
              >
                <Input placeholder="Google Map Address" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>

      <Drawer
        title="Add new vendor"
        width={500}
        onClose={() => setNewVendorDrawer(false)}
        visible={newVendorDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              onClick={() => setNewVendorDrawer(false)}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              form="newVendorForm"
              type="primary"
              htmlType="submit"
              onClick={addVendor}
            >
              Submit
            </Button>
          </div>
        }
      >
        <NewVendorForm formRef={formRef} />
      </Drawer>

      <Drawer
        title="Add attachments"
        width={500}
        onClose={() => {
          setDocumentModalVisible(false);
        }}
        destroyOnClose={true}
        visible={documentModalVisible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              onClick={() => {
                setDocumentModalVisible(false);
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              form="uploadForm"
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </div>
        }
      >
        <Form
          ref={attatchmentFormRef}
          layout="vertical"
          id="uploadForm"
          // onFinish={onFileUpload}
        >
          <Form.Item>
            <Upload
              {...{ multiple: true, maxCount: 5 }}
              beforeUpload={() => false}
              onChange={({ file, fileList }) => {
                console.log(file, fileList);
                setFileInput(fileList);
              }}
              style={{ width: "100%" }}
            >
              <Button block type="dashed" icon={<UploadOutlined />}>
                Upload
              </Button>
            </Upload>
          </Form.Item>
        </Form>
      </Drawer>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(POForm);
